import { makeRequest } from "../components/utils/APIsUtils/httpsUtils";

export default class CommonDataService {

    static async getMarketLanguages() {
        const response = await makeRequest({
            method: 'GET',
            endpoint: `/api/v1/market-languages`,
        });

        if (response != 'ERR_NETWORK' && response?.data) return response;
        else throw new Error("Failed to fetch market languages");
    }
}
